import Vue from 'vue';


export default function AuthenticatedOnlyGuard(to, from, next) {
	if (!Vue.$auth.authenticated) {
		if (to && to.name === '404') 
			next({ name: '404', replace: true });
		else if(to)
			Vue.$auth.login({ redirectUri: to.fullPath });
		else {
			var basePath = window.location.origin.toString();
			Vue.$auth.login({ redirectUri: basePath });
		}
	}
	else {
		next();	
	}
};
